<template>
    <div class="statistic flex flex-col items-start border-l-2 border-white ">
        <transition name="fade">
            <div class="lines pl-10 py-5">
                <p
                    id="firstLine"
                    :class="classes.heroStatsText">
                </p>
                <div
                    id="secondLine"
                    class="text-white text-6xl hd:text-15xl font-light">
                </div>
                <p
                    id="thirdLine"
                    :class="classes.heroStatsText">
                </p>
            </div>
        </transition>
    </div>
</template>

<script>
/* eslint-disable no-async-promise-executor */
import TypeIt from 'typeit';
import { isEmpty } from 'lodash';

export default {
  props: {
    heroStatsText: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    currentStat: null,
    currentIndex: 0,
    firstLine: null,
    secondLine: null,
    thirdLine: null,
    typing: false,
    classes: {
      heroStatsText: [
        'text-white',
        'tracking-widest',
        'uppercase',
        'text-xl',
        'font-bold ml-3',
      ],
    },
  }),
  mounted() {
    // Initialize the text array from the prop
    this.currentStat = this.heroStatsText[0];
    // Start the TypeIt Loop
    this.startTypeLoop();
  },
  methods: {
    typeLine(elementId, instance, content) {
      return new Promise((resolve) => {
        if (isEmpty(content)) {
          return resolve();
        }

        this[instance] = new TypeIt(elementId, {
          cursor: false,
          speed: instance === 'secondLine' ? 100 : 50,
          startDelay: 50,
          afterComplete: () => {
            resolve();
          },
        }).type(content).go();
      });
    },
    incrementHeroStat() {
      if (this.heroStatsText[this.currentIndex + 1] === undefined) {
        this.currentIndex = 0;
      } else {
        this.currentIndex++;
      }

      this.currentStat = this.heroStatsText[this.currentIndex];
      return this.currentStat;
    },
    resetAndContinue() {
      this.firstLine.reset().destroy();
      this.secondLine.reset().destroy();
      this.thirdLine.reset().destroy();
      this.startTypeLoop();
    },
    async startTypeLoop() {
      return (new Promise(async (resolve) => {
        await this.typeLine('#firstLine', 'firstLine', this.currentStat.heroStatsTitleOne);
        await this.typeLine('#secondLine', 'secondLine', this.currentStat.heroStatsTitleNumber);
        await this.typeLine('#thirdLine', 'thirdLine', this.currentStat.heroStatsTitleTwo);
        await resolve();
      })).then(() => {
        setTimeout(() => {
          this.incrementHeroStat();
          this.resetAndContinue();
        }, 3000);
      });
    },
  },
};
</script>

<style scoped>
    .statistic {
        min-height: 150px;
    }
</style>
